// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CaseServiceModel {
    static getAttributeTypeMap() {
        return CaseServiceModel.attributeTypeMap;
    }
}
CaseServiceModel.discriminator = undefined;
CaseServiceModel.additionalProperties = false;
CaseServiceModel.attributeTypeMap = [
    {
        "name": "serviceTypeCode",
        "baseName": "serviceTypeCode",
        "type": "string"
    },
];
//# sourceMappingURL=caseServiceModel.js.map